$ = require 'jquery'
Auth = require 'db/auth'
PopOver = require 'views/lib/pop-over'
SelectMemberRoleView = require 'views/member/select-member-role-view'
SelectNewMemberRoleView = require 'views/member/select-new-member-role-view'
Util = require 'lib/util'
View = require 'view'
track = require 'debug/track'

# Mixin for views that list members and give the option to add them,
# selecting the role
module.exports = class MemberAddView extends View
  hoverMember: (e) ->
    elem = $(e.target).closest('.item')
    Util.selectMenuItem(@$('.pop-over-member-list'), '.item', elem)

  openOption: (e) ->
    Util.stop(e)
    track("Invitations", "Open Role Selector")

    username = $(e.target).closest('.js-select-member').find('.username').text()
    memberModel = @modelCache.findOne('Member', "username", username)

    isNewUser = false
    if $(e.target).closest('.item.js-email-invite').length > 0
      isNewUser = true
      email = $(e.target).closest('.js-email-invite').find('.full-name').attr('name')

    if memberModel
      PopOver.pushView
        view: new SelectMemberRoleView
          modelCache: @modelCache
          model: memberModel
          parent: @model
          onSendInvite: @willBePopped.bind(@)
          canMakeAdmin: memberModel.get('confirmed')
    else
      PopOver.pushView
        view: new SelectNewMemberRoleView
          model: Auth.me()
          modelCache: @modelCache
          parent: @model
          email: email
          onSendInvite: @willBePopped.bind(@)
          canMakeAdmin: false
    return



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-add-view.coffee